module.exports = __webpack_public_path__ + "static/img/dDR6.a73e4d20.png";